"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = Dropdown;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/Dropdown/index.tsx
// Figma: Dropdown — ガラス面の小さなセレクト。枚数選択で使う。
//
// 構造: [ガラスの入力ボックス (幅 120px / radius.xs / px8 py12)] [単位ラベル]
// 開閉アイコンは CaretDownIcon (20px)。
//
// 色・影は theme.palette.v2 (useV2Palette) から取得する。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
var Icons_1 = require("../Icons");
function Dropdown(_a) {
    var value = _a.value, onChange = _a.onChange, options = _a.options, unit = _a.unit, _b = _a.width, width = _b === void 0 ? 120 : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, ariaLabel = _a.ariaLabel;
    var p = (0, theme_1.useV2Palette)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", spacing: "".concat(tokens_1.spacing.sm, "px"), children: [(0, jsx_runtime_1.jsx)(material_1.Select, { value: value, onChange: function (event) { return onChange(String(event.target.value)); }, disabled: disabled, variant: "standard", disableUnderline: true, IconComponent: Icons_1.CaretDownIcon, inputProps: { 'aria-label': ariaLabel }, MenuProps: {
                    PaperProps: { sx: { maxHeight: 400, overflowY: 'auto' } },
                }, sx: {
                    width: width,
                    borderRadius: "".concat(tokens_1.radius.xs, "px"),
                    backgroundColor: p.background.sub,
                    backdropFilter: "blur(".concat(tokens_1.blur.card, "px)"),
                    WebkitBackdropFilter: "blur(".concat(tokens_1.blur.card, "px)"),
                    boxShadow: p.shadow.cardGlass,
                    '& .MuiSelect-select': __assign(__assign({ boxSizing: 'border-box', px: "".concat(tokens_1.spacing.sm + tokens_1.spacing.xs, "px"), py: "".concat(tokens_1.spacing.sm + tokens_1.spacing.xs, "px") }, tokens_1.textStyles.body), { lineHeight: "".concat(tokens_1.lineHeight.sm, "px"), color: p.foreground.neutral.primary, 
                        // MUI 既定の最小高さ指定を打ち消して Figma の py:12 に合わせる
                        minHeight: 'auto' }),
                    '& .MuiSelect-icon': {
                        fontSize: 20,
                        right: tokens_1.spacing.sm,
                        color: p.foreground.neutral.primary,
                    },
                }, children: options.map(function (option) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: option.value, children: option.label }, option.value)); }) }), unit && ((0, jsx_runtime_1.jsx)(material_1.Typography, { component: "span", sx: __assign(__assign({}, tokens_1.textStyles.subtitle), { lineHeight: "".concat(tokens_1.lineHeight.sm, "px"), color: p.foreground.neutral.secondary }), children: unit }))] }));
}
